<ng-container *ngIf="!!get">
    <tt-card [ttHeading]="get.heading_acledger" ttTranslateHeading="false" ttClass="flex-1 flex-column height-full p-0">
        <tt-grid *ngIf="!!acledgerGrid" [(ttOptions)]="acledgerGrid"></tt-grid>
    </tt-card>
    <tt-card *ngIf="+get.nbr_of_acsupptrans > 0" [ttHeading]="get.heading_acsupptrans" ttTranslateHeading="false" ttClass="flex-1 flex-column height-full p-0">
        <tt-grid *ngIf="!!acsuppTransGrid" [(ttOptions)]="acsuppTransGrid"></tt-grid>
    </tt-card>
    <tt-card *ngIf="+get.nbr_of_accusttrans > 0" [ttHeading]="get.heading_accusttrans" ttTranslateHeading="false" ttClass="flex-1 flex-column height-full p-0">
        <tt-grid *ngIf="!!accustTransGrid" [(ttOptions)]="accustTransGrid"></tt-grid>
    </tt-card>
</ng-container>
